/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/DesignSystem/LetterRecipientPicker/Content/SaveAction",
  onSave,
  closePopover
  
}) {
let pickerRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'recipient_id',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onSave,
  closePopover
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onSave={onSave}
 closePopover={closePopover}
 onClick={onClick}
 data="picker.recipient_id"
 disabled={!pickerRecipientIdValueData}
 type="primary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}